import {Material} from '@wonderlandengine/api';
import {createContext, useContext} from 'react';

export interface Ss13MaterialContextValue {
    buttonMaterial: Material;
    buttonHover: Material;
}

export interface Ss13HudMaterialContextValue {}

export let Ss13MaterialContext = createContext<Ss13MaterialContextValue | null>(null);

export let useSs13MaterialContext = () => useContext(Ss13MaterialContext) as Ss13MaterialContextValue;
